// extracted by mini-css-extract-plugin
module.exports = {"layout":"settngsStyle_layout__LofEe"};